var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "refFacebookLoginButton",
      staticClass: "facebookLoginButton",
      style: [_vm.styleDebugBorder],
      attrs: { id: "facebookLoginButtonId" },
    },
    [
      !_vm.facebookLoginScriptError
        ? _c("div", { attrs: { id: "fb-root" } })
        : _vm._e(),
      _c("div", { staticClass: "d-flex just-center" }, [
        _c(
          "div",
          { staticClass: "facebookButtonOuterWrapper" },
          [
            _c(
              "div",
              {
                key: "facebookSpinnerKey",
                ref: "facebookButtonWrapper",
                staticClass: "facebookSpinnerWrapper loading",
                style: { width: _vm.buttonWidth + "px" },
                attrs: { id: "facebookSpinnerWrapperId" },
              },
              [
                _vm.facebookLoginScriptError
                  ? _c(
                      "div",
                      {
                        staticClass: "facebookErrorContainer",
                        style: { width: _vm.buttonWidth + "px" },
                      },
                      [
                        _c("div", { staticClass: "facebookLogo" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 512 512",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "errorTextWrapper" }, [
                          _c(
                            "p",
                            {
                              staticClass: "errorText",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.translatedWebMessages[
                                    "wsm_facebook_script_error"
                                  ] == "wsm_facebook_script_error"
                                    ? _vm.fbScriptErrorText
                                    : _vm.translatedWebMessages[
                                        "wsm_facebook_script_error"
                                      ]
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "It appears that the browser is preventing Facebook from loading "
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "errorText bold buttonTextOnly",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.translatedWebMessages[
                                    "wsm_facebook_script_error_solutions"
                                  ] == "wsm_facebook_script_error_solutions"
                                    ? "( " + _vm.fbScriptErrorSolutions + " )"
                                    : "( " +
                                        _vm.translatedWebMessages[
                                          "wsm_facebook_script_error_solutions"
                                        ] +
                                        " )"
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showFacebookScriptError =
                                    !_vm.showFacebookScriptError
                                },
                              },
                            },
                            [_vm._v("( Solutions )")]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isFacebookButtonLoading,
                        expression: "!isFacebookButtonLoading",
                      },
                    ],
                  },
                  [
                    _vm.responsiveClass == "flb-w400"
                      ? _c("div", {
                          key: "facebookLoginButton400",
                          staticClass: "fb-login-button flb-w400",
                          class:
                            _vm.responsiveClass == "flb-w400"
                              ? "activeFlb"
                              : "",
                          attrs: {
                            "data-width": 400,
                            "data-size": "large",
                            "data-button-type": "login_with",
                            "data-layout": "default",
                            "data-auto-logout-link": "false",
                            "data-use-continue-as": "false",
                            "data-scope": "public_profile, email",
                          },
                        })
                      : _vm._e(),
                    _vm.responsiveClass == "flb-w300"
                      ? _c("div", {
                          key: "facebookLoginButton300",
                          staticClass: "fb-login-button flb-w300",
                          class:
                            _vm.responsiveClass == "flb-w300"
                              ? "activeFlb"
                              : "",
                          attrs: {
                            "data-width": 300,
                            "data-size": "large",
                            "data-button-type": "login_with",
                            "data-layout": "default",
                            "data-auto-logout-link": "false",
                            "data-use-continue-as": "false",
                            "data-scope": "public_profile, email",
                          },
                        })
                      : _vm._e(),
                    _vm.responsiveClass == "flb-w200"
                      ? _c("div", {
                          key: "facebookLoginButton200",
                          staticClass: "fb-login-button flb-w200",
                          class:
                            _vm.responsiveClass == "flb-w200"
                              ? "activeFlb"
                              : "",
                          attrs: {
                            "data-width": 200,
                            "data-size": "medium",
                            "data-button-type": "login_with",
                            "data-layout": "default",
                            "data-auto-logout-link": "false",
                            "data-use-continue-as": "false",
                            "data-scope": "public_profile, email",
                          },
                        })
                      : _vm._e(),
                  ]
                ),
                _vm.isFacebookButtonLoading && !_vm.facebookLoginScriptError
                  ? _c("loadingBalls", {
                      key: "loadingBalls",
                      attrs: {
                        ballColor: ["#e7f1fd", "#b9d6fb", "#8bbbf8", "#5d9ff5"],
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c("Transition", { attrs: { name: "slideDown" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (!_vm.isFacebookButtonLoading &&
                          _vm.isUserConnectedToFacebook) ||
                        _vm.showFacebookScriptError,
                      expression:
                        "(!isFacebookButtonLoading && isUserConnectedToFacebook)|| showFacebookScriptError",
                    },
                  ],
                  staticClass: "facebookButtonUserInfo",
                  style: { width: _vm.buttonWidth + "px" },
                },
                [
                  _vm.facebookLoginScriptError
                    ? _c(
                        "div",
                        {
                          staticClass: "facebookLoginScriptError",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.translatedWebMessages[
                                "wsm_facebook_script_error_helpText"
                              ] == "wsm_facebook_script_error_helpText"
                                ? _vm.fbScriptErrorHelpText
                                : _vm.translatedWebMessages[
                                    "wsm_facebook_script_error_helpText"
                                  ]
                            ),
                          },
                        },
                        [
                          _c("p", { staticClass: "title" }, [
                            _vm._v("Possible solution(s):"),
                          ]),
                          _c("p", [
                            _vm._v(
                              'If you\'re using "Private browsing" try to disable it.'
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.isUserConnectedToFacebook
                    ? _c("div", { staticClass: "d-flex flex-wrap" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "facebookButtonUserInfoText fbText fbCol bold",
                          },
                          [
                            _c("span", {
                              staticClass: "fbText fbCol bold",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.translatedWebMessages[
                                    "wsm_facebook_welcome_user"
                                  ] == "wsm_facebook_welcome_user"
                                    ? "Welcome"
                                    : _vm.translatedWebMessages[
                                        "wsm_facebook_welcome_user"
                                      ]
                                ),
                              },
                            }),
                            _vm._v(
                              ", " + _vm._s(_vm.fbAPI["short_name"]) + " "
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "facebookChangeUserText",
                            on: {
                              click: function ($event) {
                                _vm.showFacebookLogoutContainer =
                                  !_vm.showFacebookLogoutContainer
                              },
                            },
                          },
                          [
                            _vm._v("("),
                            _c("span", {
                              staticClass: "fbText",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.translatedWebMessages[
                                    "wsm_facebook_are_you_not_user"
                                  ] == "wsm_facebook_are_you_not_user"
                                    ? "Are you not"
                                    : _vm.translatedWebMessages[
                                        "wsm_facebook_are_you_not_user"
                                      ]
                                ),
                              },
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.fbAPI["short_name"]) + "?)"
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.showFacebookLogoutContainer
                    ? _c("div", { staticClass: "facebookLogoutContainer" }, [
                        _c("div", { staticClass: "facebookHorizontalLine" }),
                        _c(
                          "button",
                          {
                            staticClass: "facebookLogoutButton",
                            on: { click: _vm.logoutFacebook },
                          },
                          [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.translatedWebMessages[
                                    "wsm_facebook_logout"
                                  ] == "wsm_facebook_logout"
                                    ? "Logout"
                                    : _vm.translatedWebMessages[
                                        "wsm_facebook_logout"
                                      ]
                                ),
                              },
                            }),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.showFacebookLogoutContainer &&
                  _vm.isUserConnectedToFacebook
                    ? _c(
                        "div",
                        {
                          staticClass: "facebookLogoutHelpContainerWrapper",
                          class:
                            _vm.responsiveClass == "flb-w200"
                              ? "responsive"
                              : "",
                        },
                        [
                          _c("div", { staticClass: "d-flex align-center" }, [
                            _c("div", { staticClass: "questionmarkIcon" }, [
                              _vm._v("?"),
                            ]),
                            _c(
                              "button",
                              {
                                staticClass: "buttonTextOnly",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    _vm.showFacebookLogoutHelperText =
                                      !_vm.showFacebookLogoutHelperText
                                  },
                                },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.translatedWebMessages[
                                          "wsm_facebook_logout_trouble"
                                        ] == "wsm_facebook_logout_trouble"
                                          ? "Having trouble logging out of facebook?"
                                          : _vm.translatedWebMessages[
                                              "wsm_facebook_logout_trouble"
                                            ]
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " Having trouble logging out of facebook? "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _c("Transition", { attrs: { name: "slideDown" } }, [
                            _vm.showFacebookLogoutHelperText
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "facebookLogoutHelpContainer",
                                  },
                                  [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.translatedWebMessages[
                                            "wsm_facebook_logout_helpText"
                                          ] == "wsm_facebook_logout_helpText"
                                            ? _vm.fbHelpText
                                            : _vm.translatedWebMessages[
                                                "wsm_facebook_logout_helpText"
                                              ]
                                        ),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }